export default __webpack_public_path__ + "static/media/carta1.94ce3e22.png";